// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"187":"page-services","206":"page-about","244":"page-work","309":"page-contact","390":"page-home"}[chunkId] + "." + {"187":"6f702f33","206":"097c9232","244":"c1f641b6","309":"a79f601b","390":"6d3fcb6c"}[chunkId] + ".chunk.css";
};